import { render } from "./econoSearch.vue?vue&type=template&id=08f9d428&scoped=true"
import script from "./econoSearch.vue?vue&type=script&lang=js"
export * from "./econoSearch.vue?vue&type=script&lang=js"

import "./econoSearch.vue?vue&type=style&index=0&id=08f9d428&lang=scss&scoped=true"

import exportComponent from "E:\\项目\\经济运行\\econo-eco-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f9d428"]])

export default __exports__